import { render, staticRenderFns } from "./lastRiskConfirm.vue?vue&type=template&id=ba6f62b4&scoped=true"
import script from "./lastRiskConfirm.vue?vue&type=script&lang=js"
export * from "./lastRiskConfirm.vue?vue&type=script&lang=js"
import style0 from "./lastRiskConfirm.vue?vue&type=style&index=0&id=ba6f62b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f62b4",
  null
  
)

export default component.exports